export const EVENT_TYPES = {
  PREVOTING: "prevoting",
  CONCERT: "concert",
  KARAOKE: "karaoke"
};

export function normalizeEventType(eventType, fallback = EVENT_TYPES.CONCERT) {
  if (!eventType) return fallback;
  const value = String(eventType).trim().toLowerCase();
  if (Object.values(EVENT_TYPES).includes(value)) {
    return value;
  }
  return fallback;
}

export function resolveEventType(event) {
  if (!event) return EVENT_TYPES.CONCERT;
  if (event.eventType != null && String(event.eventType).trim() !== "") {
    return normalizeEventType(event.eventType);
  }
  return EVENT_TYPES.CONCERT;
}

export function isKaraokeEvent(event) {
  return resolveEventType(event) === EVENT_TYPES.KARAOKE;
}
